const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  user: state => state.user,
  course: state => state.course,
  studentList: state => state.app.studentList,
  checkedStudentData: state => state.app.checkedStudentData
}
export default getters
